module.exports = __webpack_public_path__ + "img/menu-thai-express-complete.84c01e3e.webp";